<template>
  <s-topbar :color="color">
    <template #left>
      <NuxtLink :to="rotaHome(user?.tipo_id)" class="topbar-marca" aria-label="Ir para o início">
        <img src="@/public/logo/icon_large.png" alt="" height="32" />
        <h3 class="topbar-title">Portal Quinyx</h3>
      </NuxtLink>
    </template>

    <template #right>
      <topbar-escola-popover v-model:color="color" v-if="showEscolaPopover" />
      <s-divider orientation="vertical" length="60%" v-if="showEscolaPopover" />

      <s-button
        v-if="equipe"
        variant="icon"
        icon="mdiHelpCircleOutline"
        tooltip="Guias de uso"
        aria-label="Guias de uso"
        @click="navigateTo('/guias')"
      />
      <s-button
        variant="icon"
        :icon="telaCheia ? 'mdiFullscreenExit' : 'mdiFullscreen'"
        :tooltip="telaCheia ? 'Sair da tela cheia' : 'Tela cheia'"
        :aria-label="telaCheia ? 'Sair da tela cheia' : 'Tela cheia'"
        @click="alternarTelaCheia"
      />

      <s-divider orientation="vertical" length="60%" />
      <topbar-usuario-popover />
    </template>
  </s-topbar>
</template>

<script lang="ts" setup>
import type { Color } from '@sieg-ad/componentes-vue';
import { useAuthStore } from '~/stores/auth';
import { rotaHome } from '~/constants/roles';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const color = ref<Color>('secondary');
const telaCheia = ref(false);

const showEscolaPopover = computed(() => user.value?.tipo_id === 3);
//? Mesma regra de /guias em ~/constants/roles.
const equipe = computed(() => authStore.isAdministrador || authStore.isGestor || authStore.isDocente);

// METHODS

//? Tela cheia ajuda no Display da sala; o estado vem do evento (o usuário também sai com Esc).
const alternarTelaCheia = () => document.fullscreenElement
  ? document.exitFullscreen()
  : document.documentElement.requestFullscreen();

const sincronizarTelaCheia = () => telaCheia.value = Boolean(document.fullscreenElement);

// LYFECYCLE

onMounted(() => document.addEventListener('fullscreenchange', sincronizarTelaCheia));
onBeforeUnmount(() => document.removeEventListener('fullscreenchange', sincronizarTelaCheia));
</script>

<style>
.topbar-marca {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.topbar-title {
  margin: 0 0 0 8px;
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--secondary);
}

/* No escuro o marinho some no fundo da barra. */
[data-theme="dark"] .topbar-title {
  color: var(--text-primary);
}
</style>
